import Vue from 'vue';
import VueRouter from 'vue-router';
// import Cookie from 'js-cookie';
const originalPush = VueRouter.prototype.push;
// import { getTsCode } from '@/api/login';

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);
import Layout from '@/components/layout';
const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    name: 'login'
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      //大洲管理
      {
        path: 'continent',
        component: () => import('@/views/continent/continent'),
        name: 'continent'
      },
      //首页
      {
        path: 'home',
        component: () => import('@/views/home/home'),
        name: 'home',
      },
      //国家管理 country
      {
        path: 'country',
        component: () => import('@/views/country/country'),
        name: 'country',
      },
      //分类管理 visaCategory
      {
        path: 'visaCategory',
        component: () => import('@/views/visaCategory/visaCategory'),
        name: 'visaCategory',
      },
      //申请人身份 
      {
        path: 'applicantIdentity',
        component: () => import('@/views/applicantIdentity/applicantIdentity'),
        name: 'applicantIdentity',
      },
      //
      {
        path: 'applicantInformation',
        component: () => import('@/views/applicantInformation/applicantInformation'),
        name: 'applicantInformation',
      },
      //资料管理electronicForm
      {
        path: 'electronicForm',
        component: () => import('@/views/electronicForm/electronicForm'),
        name: 'electronicForm',
      },
      //签证管理 
      {
        path: 'visa',
        component: () => import('@/views/visa/visa'),
        name: 'visa',
      },
      //签证管理 
      {
        path: 'order',
        component: () => import('@/views/order/order'),
        name: 'order',
      },
      //账号管理
      {
        path: 'account',
        component: () => import('@/views/account/account'),
        name: 'account',
      },
      //账号管理
      {
        path: 'accountChecking',
        component: () => import('@/views/accountChecking/accountChecking'),
        name: 'accountChecking',
      },
      {
        path: 'financeData',
        component: () => import('@/views/financeData/financeData'),
        name: 'financeData',
      },
      {
        path: 'consularDistrict',
        component: () => import('@/views/system/consularDistrict/index'),
        name: 'consularDistrict',
      },
      {
        path: 'basicInfo',
        component: () => import('@/views/system/basicInfo/index'),
        name: 'basicInfo',
      },
      {
        path: 'visaTerm',
        component: () => import('@/views/term/term'),
        name: 'visaTerm',
      },
      {
        path: 'visaTermAdd',
        component: () => import('@/views/term/components/termAdd'),
        name: 'visaTermAdd',
      },
      {
        path: 'visaUserProtocol',
        component: () => import('@/views/visaUserProtocol/visaUserProtocol'),
        name: 'visaUserProtocol',
      },
      {
        path: 'visaUserProtocolAdd',
        component: () => import('@/views/visaUserProtocol/components/visaUserProtocolAdd'),
        name: 'visaUserProtocolAdd',
      },
      {
        path: 'userPrivacy',
        component: () => import('@/views/userPrivacy/userPrivacy'),
        name: 'userPrivacy',
      },
      {
        path: 'userPrivacyAdd',
        component: () => import('@/views/userPrivacy/components/userPrivacyAdd'),
        name: 'userPrivacyAdd',
      },
    ]
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});
// router.beforeEach((to, from, next) => {
//   console.log(to);
//   if (to.path == '/login') {
//     console.log('开始判断');
//     if (Cookie.get('tgt') != undefined) {
//       var obj = {
//         tgt: Cookie.get('tgt'),
//         serviceUrl: this.$route.params.service,
//       };
//       getTsCode(obj).then((msg) => {
//         console.log(msg);
//         if (msg.code == 200) {
//           window.location.href =
//             this.$route.params.service + '?' + 'ticket=' + msg.data;
//         }
//       });
//     } else {
//       next();
//     }
//   } else {
//     if (Cookie.get('tgt') == undefined) {
//       router.push('/login');
//     } else {
//       next();
//     }
//   }
// });
export default router;
